import { createSelector } from 'reselect'

import {
  workflowSelector,
  combinedTriggerTypeSelector,
  workflowRuleTimeValueSelector,
  workflowRuleTimeUnitsSelector,
  workflowLoadingStateSelector,
  workflowRequestErrorSelector
} from './builder'

const ownerListSelector = ({ workflows: { owner_list: ownerList } }) => ownerList

export const ownerListLoadedSelector = createSelector(
  ownerListSelector,
  ({ loaded }) => loaded
)

export const ownerCollectionSelector = createSelector(
  ownerListSelector,
  ({ collection }) => collection
)

export const paginationSelector = createSelector(
  ownerListSelector,
  ({ pagination }) => pagination
)

export const workflowIsCreatedSelector = createSelector(
  ownerListSelector,
  ({ workflow_created: workflowCreated }) => Boolean(workflowCreated)
)

export const firstAndOnlyOwnerSelector = createSelector(
  ownerCollectionSelector,
  (collection) => (
    collection.length === 1 && collection[0]
  )
)

const ownerWorkflowsAmount = createSelector(
  firstAndOnlyOwnerSelector,
  (owner) => (Boolean(owner) && owner.workflows.collection.length)
)

export const isWorkflowCollectionEmptySelector = createSelector(
  ownerWorkflowsAmount,
  (amount) => amount === 0
)

export const conflictingEventTypesSelector = createSelector(
  ownerListSelector,
  ({
    workflow_created: workflowCreated
  }) => (workflowCreated && workflowCreated.conflicting_event_types)
)

export const conflictingEventTypesPresentSelector = createSelector(
  conflictingEventTypesSelector,
  (conflictingEventTypes) => (
    conflictingEventTypes && conflictingEventTypes.length > 0
  )
)

export const workflowsOwnerNameSelector = ({
  workflows: { owner: { name } }
}) => name

const workflowsEventTypesSelector = ({ workflows: { event_types: eventTypes } }) => eventTypes

export const workflowsEventTypesCollectionSelector = createSelector(
  workflowsEventTypesSelector,
  ({ collection }) => collection
)

export const workflowEventTypesPaginationSelector = createSelector(
  workflowsEventTypesSelector,
  ({ pagination }) => pagination
)

export const workflowsEventTypesLoadingStateSelector = createSelector(
  workflowsEventTypesSelector,
  ({ loadingState }) => loadingState
)

export const workflowsOwnerSelector = (state) => state.workflows.owner

export {
  workflowSelector,
  combinedTriggerTypeSelector,
  workflowRuleTimeValueSelector,
  workflowRuleTimeUnitsSelector,
  workflowLoadingStateSelector,
  workflowRequestErrorSelector
}
